import Menu from 'components/Menu';
import AlarmButton from './components/AlarmButton';
import AlarmMenu from './components/AlarmMenu';
import useAlarm from './hooks/useAlarm';

const Alarm = () => {
  const { alarms, isAlarmUpdated, handleAlarmCloseClick, handleTriggerClick } = useAlarm();

  return (
    <Menu trigger={<AlarmButton isAlarmUpdated={isAlarmUpdated} />} onTriggerClick={handleTriggerClick} minWidth={340}>
      <AlarmMenu alarms={alarms} onAlarmCloseClick={handleAlarmCloseClick} />
    </Menu>
  );
};

export default Alarm;
